import { useState, useEffect } from "react";
import { auth, db } from "../network/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";

export const useAuth = () => {
    const [user, setUser] = useState(null);
    const [users, setUsers] = useState([]); // 👈 store all users
    const [loading, setLoading] = useState(true);
    const [usersLoading, setUsersLoading] = useState(true); // 👈 loading state for users list

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                try {
                    const userRef = doc(db, "users", currentUser.uid);
                    const employeeRef = doc(db, "employee", currentUser.uid);

                    const [userSnap, employeeSnap] = await Promise.all([
                        getDoc(userRef, { source: "server" }),
                        getDoc(employeeRef, { source: "server" }),
                    ]);

                    if (userSnap.exists()) {
                        const data = userSnap.data();
                        setUser({ uid: currentUser.uid, ...data });
                    } else if (employeeSnap.exists()) {
                        const data = employeeSnap.data();
                        setUser({ uid: currentUser.uid, ...data });
                    } else {
                        setUser({
                            uid: currentUser.uid,
                            email: currentUser.email,
                            role: "unassigned",
                        });
                    }
                } catch (err) {
                    console.error("Failed to fetch user info:", err);
                    setUser({ uid: currentUser.uid, email: currentUser.email });
                }
            } else {
                setUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    // 👇 Load all users (admin + employee)
    useEffect(() => {
        const loadAllUsers = async () => {
            try {
                setUsersLoading(true);

                const [usersSnap, employeesSnap] = await Promise.all([
                    getDocs(collection(db, "users")),
                    // getDocs(collection(db, "employee")),
                ]);

                const allUsers = [
                    ...usersSnap.docs.map((doc) => ({
                        id: doc.id,
                        ...doc.data(),
                    })),
                    // ...employeesSnap.docs.map((doc) => ({
                    //     id: doc.id,
                    //     ...doc.data(),
                    // })),
                ];

                setUsers(allUsers);
            } catch (err) {
                console.error("Failed to load all users:", err);
            } finally {
                setUsersLoading(false);
            }
        };

        loadAllUsers();
    }, []);

    return { user, users, loading, usersLoading };
};


// import { useState, useEffect } from "react";
// import { auth, db } from "../network/firebaseConfig";
// import { onAuthStateChanged } from "firebase/auth";
// import { doc, getDoc } from "firebase/firestore";

// export const useAuth = () => {
//     const [user, setUser] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//             if (currentUser) {
//                 // console.log("currentUser:", currentUser.uid, currentUser.email);
//                 try {
//                     const userRef = doc(db, "users", currentUser.uid);
//                     const employeeRef = doc(db, "employee", currentUser.uid);

//                     const [userSnap, employeeSnap] = await Promise.all([
//                         getDoc(userRef, { source: "server" }),
//                         getDoc(employeeRef, { source: "server" }),
//                     ]);
//                     if (userSnap.exists()) {
//                         const data = userSnap.data();
//                         console.log("Fetched user data:", data);
//                         setUser({ uid: currentUser.uid, ...data });
//                     } else if (employeeSnap.exists()) {
//                         const data = employeeSnap.data();
//                         console.log("Fetched employee data:", data);
//                         setUser({ uid: currentUser.uid, ...data });
//                     } else {
//                         console.warn("No user or employee document found!");
//                         setUser({ uid: currentUser.uid, email: currentUser.email, role: "unassigned" });
//                     }
//                 } catch (err) {
//                     console.error("Failed to fetch user info:", err);
//                     setUser({ uid: currentUser.uid, email: currentUser.email });
//                 }
//             } else {
//                 setUser(null);
//             }
//             setLoading(false);
//         });


//         return () => unsubscribe();
//     }, []);

//     return { user, loading };
// };